import {
  UnstyledButtonProps as MantineUnstyledButtonProps,
  UnstyledButton as MantineUnstyledButton,
} from '@mantine/core';

export type UnstyledButtonProps = MantineUnstyledButtonProps;

export const UnstyledButton =
  MantineUnstyledButton as typeof MantineUnstyledButton;

UnstyledButton.displayName = 'UnstyledButton';
